export default {
  ADMIN: 1,
  GENERAL: 3,
  CONTROLLER_1: 4,
  CONTROLLER_2: 5,
  RECEPRIONIST: 7,
  MATERIAL_MAN: 8,
  DRIVER: 9,
  MAINTENANCE_DO: 10,
  HUB_SUPERVISOR: 11,
  FIELD: 12
}



// WEBPACK FOOTER //
// ./src/constants/Roles.js